import type { Node } from '@xyflow/react'

const GROUP_NODE_TYPE = 'group'

export function isGroupContainerNode(node: Pick<Node, 'type'>) {
  return node.type === GROUP_NODE_TYPE
}

export function collectGroupDescendantNodes(groupId: string, nodes: Node[]) {
  const childrenByParentId = new Map<string, Node[]>()

  nodes.forEach((node) => {
    if (!node.parentId) return

    const children = childrenByParentId.get(node.parentId) ?? []
    children.push(node)
    childrenByParentId.set(node.parentId, children)
  })

  const descendants: Node[] = []
  const visitedParentIds = new Set<string>()

  const walk = (parentId: string) => {
    if (visitedParentIds.has(parentId)) return

    visitedParentIds.add(parentId)
    const children = childrenByParentId.get(parentId) ?? []
    children.forEach((child) => {
      descendants.push(child)
      walk(child.id)
    })
  }

  walk(groupId)
  return descendants
}
